import React from "react";
import { Anclas } from "../../UI/Anclas/Anclas";

export const NoUserHistory = () => {
  return (
    <section id="NoUserPersonalized">
      <div id="ContainerIconAnchor">
        <span id="iconAnchor" className="material-symbols-outlined">history</span>
      </div>

      <h2>Revisa tus trabajos anteriores</h2>
      <p>Debes acceder a tu cuenta para ver el historial de trabajos.</p>
      <Anclas
        estilos="AnchorAccount"
        enlace="/auth"
        textoAncla={
          <div id="account">
            <span className="material-symbols-outlined">account_circle</span>
            Acceder
          </div>
        }
      />
    </section>
  );
};
